import { render, staticRenderFns } from "./NotificationListTable.vue?vue&type=template&id=3deec026"
import script from "./NotificationListTable.vue?vue&type=script&lang=js"
export * from "./NotificationListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports